const data = [
  {
    id: 1,
    person: "Gowthaman shanmugam",
    icon: "⭕️",
    status: "Open",
    title: "Human Interest Form",
    college: "RMK college of engineering and technology",
    content: "Full stack developer",
  },
  {
    id: 2,
    person: "Ankur srivatsava",
    icon: "⭕️",
    status: "Open",
    title: "Purchase present",
    college: "SRM engineering college",
    content: "Frontend developer",
  },
  {
    id: 3,
    person: "Vignesh R",
    icon: "⭕️",
    status: "Open",
    title: "Invest in investments",
    college: "Panimalar engineering college",
    content: "Backend developer",
  },
  {
    id: 4,
    person: "Sanjay R",
    icon: "⭕️",
    status: "Open",
    title: "Daily reading",
    college: "P.S.G enineering college",
    content: "Test engineer",
  },
];

const statuses = [
  {
    status: "Open",
    icon: "⭕️",
    color: "#EB5A46",
  },
  {
    status: "Contacted",
    icon: "🔆️",
    color: "#00C2E0",
  },
  {
    status: "Written test",
    icon: "📝",
    color: "#C377E0",
  },
  {
    status: "Written test completed",
    icon: "✅",
    color: "#3981DE",
  },
];

export { data, statuses };
